
import Vue from 'vue';
import { dateFormat } from '@/helpers/dateFormat';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  computed: {
    todaysDate: function(): string {
      return this.formatDate(new Date().toISOString());
    },
    customerDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    startDate: function(): any {
      return this.getVariable(this.input.config.startDateVariable);
    },
    endDate: function(): any {
      return this.getVariable(this.input.config.endDateVariable);
    }
  },
  methods: {
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
